import { useContext } from "react"
import Attendee from "./Attendee"
import RegisterableContext from "components/admin/registerable/context"
import { number } from "prop-types"
import { capitalize } from "utils/helpers"

const SelectionAttendees = ({ id }) => {
  const {
    registerable: { attendees, attendeeTypeSelections }
  } = useContext(RegisterableContext)
  const selection = attendeeTypeSelections.find(selection => selection.id === id)
  const selectionAttendees = attendees
    .filter(
      ({ attendeeTypeId, isWaitlisted }) =>
        attendeeTypeId == selection.attendeeTypeId && isWaitlisted == selection.waitlist
    )
    .slice(0, selection.count)

  for (let i = selectionAttendees.length; i < selection.count; i++) {
    selectionAttendees.push({ id: `placeholder-${selection.id}-${i}`, placeholder: true })
  }

  return (
    <>
      {selectionAttendees.map(({ id, placeholder }, i) => (
        <Attendee
          key={id}
          id={id}
          selectionName={`${capitalize(selection.name)} ${i + 1}`}
          placeholder={placeholder}
        />
      ))}
    </>
  )
}

SelectionAttendees.propTypes = {
  id: number.isRequired
}

export default SelectionAttendees
